import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import request from "../util/request";
import { deleteDatabase } from "indexedb";

import {
  SIGNIN_USER,
  SIGNOUT_USER,
  GET_LIST_OF_COUNTRIES,
} from "constants/ActionTypes";

import {
  show_auth_message,
  user_sign_in_success,
  user_sign_in_failed,
  user_sign_out_success,
  get_list_of_countries_success,
  get_list_of_countries_failed,
} from "actions/Auth";
import { deleteToken, removeCookie } from "util/helpers";

// import { verify_otp_success } from "actions/otp";

// import { setCookie } from "util/helpers";

const signin_user_request = async (payload) =>
  await request({
    path: "/login",
    method: "POST",
    body: JSON.stringify(payload),
  });

// add logout path,method ,body and pas payload
const signout_user_request = async () =>
  // payload
  await request({
    path: "/logout",
    method: "GET",
  })
    .then((authUser) => authUser)
    .catch((error) => error);

function* signin_user_saga({ payload }) {
  try {
    const response = yield call(signin_user_request, payload);
    if (
      response.status === 200 &&
      response.code === "user_verified_check_otp"
    ) {
      yield put(user_sign_in_success(response));
    //   localStorage.setItem("user_id", response.data.user_id);
    //   // document.cookie = `token=${response.data.token};path=/`;
    //   setCookie("token", response.data.token);
    //   yield put(verify_otp_success(response.data));
    //   window.location = "/";
    } else {
      // yield put(show_auth_message(response.message));
      yield put(
        user_sign_in_failed({
          message: response.message,
          code: response.code,
        })
      );
    }
  } catch (error) {
    console.error(error);
    yield put(show_auth_message(error));
  }
}

function* signout_user_saga(payload) {
  try {
    const signOutUser = yield call(signout_user_request, payload);

    if (signOutUser.status === 200) {
      localStorage.removeItem("user_id");
      sessionStorage.clear();
      deleteDatabase();
      removeCookie("token");
      deleteToken();
      window.location = "/";
      yield put(user_sign_out_success(signOutUser));
    } else {
      yield put(show_auth_message(signOutUser.message));
    }
  } catch (error) {
    console.error(error);
    yield put(show_auth_message(error));
  }
}

function* get_list_of_countries_saga() {
  // payload
  try {
    const response = yield call(request, {
      path: "/countries",
      method: "GET",
    });

    if (response.status === 200) {
      yield put(get_list_of_countries_success(response.data));
    } else {
      yield put(get_list_of_countries_failed());
    }
  } catch (error) {
    console.error(error);
    yield put(get_list_of_countries_failed());
  }
}

export function* signin_user() {
  yield takeLatest(SIGNIN_USER, signin_user_saga);
}

export function* signout_user() {
  yield takeLatest(SIGNOUT_USER, signout_user_saga);
}

export function* get_list_of_countries() {
  yield takeLatest(GET_LIST_OF_COUNTRIES, get_list_of_countries_saga);
}

export default function* rootSaga() {
  yield all([
    fork(signin_user),
    fork(signout_user),
    fork(get_list_of_countries),
  ]);
}
